import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Modal from 'react-responsive-modal';
/* import styles from './VideoPlayer.scss';// to import local scss fle  */
import queryString from 'query-string';

import styles from './VideoPlayer.scss';

const modalStyle = {
  width: '100%',
  padding: '0',
  height: '100%',
  maxWidth: 'inherit',
};


class VideoPlayer extends Component {
  static propTypes = {
    removeVideoScreen: PropTypes.func.isRequired,
    currentVideoUrl: PropTypes.string,
    showVideo: PropTypes.bool,
  };

  static defaultProps = {
    currentVideoUrl: '',
    showVideo: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.getUrl = this.getUrl.bind(this);
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    if (this.props.showVideo) {
      this.props.removeVideoScreen();
    }
  }

  /* eslint-disable */
  getUrl(url) {
    const query = queryString.parse(url);
    let id = '';
    if (query && Object.prototype.hasOwnProperty.call(query, 'https://www.youtube.com/watch?v')) {
      id = query['https://www.youtube.com/watch?v'];
    }
    return (`https://www.youtube.com/embed/${id}`);
  }
  /* eslint-enable */

  render() {
    const { showVideo, currentVideoUrl } = this.props;
    return (
      <div >
        <Modal
          closeIconClassName={styles.closeButton}
          modalStyle={modalStyle}
          open={showVideo}
          onClose={this.onCloseModal}
        >
          <iframe
            src={this.getUrl(currentVideoUrl)}
            width="100%" height="100%" frameBorder="0" allowFullScreen
          />
        </Modal>
      </div>
    );
  }
}

export default VideoPlayer;




// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.js